<div
    class="header"
    *ngIf="headline"
    [ngClass]="{ clickable: clickableHeader }"
    (click)="onHeaderClick($event)">
    <div class="inner">
        <div
            class="headline-icon"
            *ngIf="headlineIcon"
            [uiTooltip]="headline">
            <ui-svg-icon [icon]="headlineIcon"></ui-svg-icon>
        </div>
        <span
            class="headline"
            [class.inactive]="inactive"
            [uiTooltip]="headline"
            >{{ headline }}</span
        >
    </div>
    <span
        [hidden]="!toggle"
        class="toggle-action"
        (click)="toggleProperties()">
        {{ toggleText }}</span
    >
    <ng-container *ngIf="customAction">
        <ng-container *ngTemplateOutlet="customAction"></ng-container>
    </ng-container>

    <div
        class="action"
        #actionElement>
        <ng-content select="[section-header-action]"></ng-content>
        <ng-container *ngIf="dropdownTarget">
            <ui-svg-icon
                icon="kebab"
                [uiDropdownTarget]="dropdownTarget"></ui-svg-icon>
        </ng-container>
        <ng-container *ngIf="!dropdownTarget">
            <ui-svg-icon
                *ngFor="let a of actions"
                [attr.id]="a.id"
                [style.display]="a.hidden ? 'none' : 'inline-block'"
                [icon]="a.icon"
                (click)="executeAction(a, $event)"></ui-svg-icon>
        </ng-container>
        <ui-svg-icon
            *ngIf="collapsable"
            class="collapse-button"
            [ngClass]="{ collapsed: collapsed }"
            (click)="collapsed = !collapsed"
            icon="arrow-down"></ui-svg-icon>
    </div>
</div>
<div
    #sectionBody
    class="section-body ui-scrollbar"
    [style.display]="collapsed || empty ? 'none' : 'block'">
    <ng-content></ng-content>
</div>
